import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { AuthOtpService } from '../auth/auth-otp.service';
import { isPlatformBrowser } from '@angular/common';
import { LanguageService } from '../services/Language/lang.service';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return next(req);
  }

  const auth = inject(AuthOtpService);
  const languageService = inject(LanguageService);
 
  const token = auth.getAccessToken();
  const lang = languageService.getLang();

  const isPublicEndpoint =
    req.url.includes('/auth/customer/') ||
    req.url.includes('/contact/create/') ||
    req.url.includes('/reviews/');

  const headers: Record<string, string> = {
    'Accept-Language': lang
  };

  if (token && !isPublicEndpoint) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  req = req.clone({
    setHeaders: headers
  });

  return next(req);
};